export default __webpack_public_path__ + "c12dbbea5a1e4701dacfec0d4cdaf78c.svg";